import script from "./ProductTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ProductTemplate.vue?vue&type=style&index=0&id=07a7bb04&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a7bb04"]])

export default __exports__